import { render, staticRenderFns } from "./DeleteDeviceModal.vue?vue&type=template&id=cdc5afb4"
import script from "./DeleteDeviceModal.vue?vue&type=script&lang=js"
export * from "./DeleteDeviceModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports